import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function TermsAcceptance({ checked, onChange, prefix = 'account' }) {
  const { t, i18n } = useTranslation();
  return <div className="flex items-start gap-3 text-sm text-gray-700">
    <input id={`${prefix}-terms`} name="ageConfirmed" type="checkbox" required checked={checked || false} onChange={onChange}
      data-testid={`${prefix}-age-checkbox`} className="mt-1 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
    <label htmlFor={`${prefix}-terms`}>{t('register.acceptTerms')}{' '}
      <Link className="text-blue-600 underline" to={`/${i18n.language}/terms-and-conditions`} target="_blank" rel="noopener noreferrer">{t('register.termsAndConditions')}</Link>
    </label>
  </div>;
}
